// @flow
import React from 'react';

/**
 * This is necessary because React Native fails when it finds components that weren't imported from anywhere (like when
 * you use standard HTML/SVG tags). By putting these components in a module, we can easily swap them for the ones from
 * react-native-svg on the native side.
 */
export default {
    Svg: (props: any) => <svg {...props} />,
    G: (props: any) => <g {...props} />,
    Path: (props: any) => <path {...props} />,
    Line: (props: any) => <line {...props} />,
    Circle: (props: any) => <circle {...props} />,
    Ellipse: (props: any) => <ellipse {...props} />,
    LinearGradient: (props: any) => <linearGradient {...props} />,
    RadialGradient: (props: any) => <radialGradient {...props} />,
    Polygon: (props: any) => <polygon {...props} />,
    Polyline: (props: any) => <polyline {...props} />,
    Rect: (props: any) => <rect {...props} />,
    Symbol: (props: any) => <symbol {...props} />,
    Text: (props: any) => <text {...props} />,
    Use: (props: any) => <use {...props} />,
    Defs: (props: any) => <defs {...props} />,
    Stop: (props: any) => <stop {...props} />
};



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/svg-components.js